import React from 'react'
import { connect as connectRedux } from 'react-redux'
import { Map } from 'immutable'
import compose from 'recompose/compose'
import { getBoundActions } from '../../actions/index'
import { PROMO_UNIT_CLICK_GA4_EVENT, RESTART_SUBSCRIPTION_CLICKED_GA4_EVENT } from '../../services/event-tracking/index'
import { H2 } from '../Heading/index'
import Button, { TYPES } from '../Button/index'
import { URL_CHECKOUT } from '../../services/url/constants'

function getEventData (props) {
  const {
    data,
    promotionContentId,
    promotionContentType,
    rowPlacement,
  } = props
  const title = data.get('title')

  // GA4 event
  return {
    promo_name: title,
    content_id: promotionContentId,
    content_type: promotionContentType,
    content_name: title,
    row_placement: rowPlacement,
    row_name: title,
    tile_number: 0,
    click_attribution: 'Member Home',
  }
}

/**
 * The click function for the promotion cta button
 * @param {Object} props - the props
 * @param {Map} props.data - The promotion data
 */
function handleClick (props) {
  const { setEventDefault, sendOptimizelyFeatureEvent } = props
  const eventData = getEventData(props)

  // GA4 events
  setEventDefault(PROMO_UNIT_CLICK_GA4_EVENT.mergeDeep(eventData))
  setEventDefault(RESTART_SUBSCRIPTION_CLICKED_GA4_EVENT.mergeDeep({
    ui_element: 'Promotion',
  }))

  // Optimizely event
  sendOptimizelyFeatureEvent({ eventName: 'restart_subscription_clicked' })
}

function PromotionWinback (props) {
  const {
    data,
    promoRef,
    sectionId,
  } = props

  const title = data.get('title')
  const description = data.get('teaser')
  const ctaLabel = data.getIn(['cta', 'label'])

  return (
    <div ref={promoRef} className="promotion promotion-winback" data-page-manager-section-id={sectionId}>
      <div className="promotion-winback__overlay" />
      <div className="promotion-winback__wrapper">
        <H2 className="promotion-winback__title">{title}</H2>
        <p className="promotion-winback__description">{description}</p>
        <Button
          className="promotion-winback__cta"
          type={TYPES.PRIMARY}
          url={URL_CHECKOUT}
          scrollToTop
          onClick={() => handleClick(props)}
        >
          {ctaLabel}
        </Button>
      </div>
    </div>
  )
}

export default compose(
  connectRedux(
    (state, props) => {
      const {
        pmSection,
        staticText,
      } = state
      const { sectionId } = props
      const promotionContentId = pmSection.getIn([sectionId, 'data', 'data', 'tabs', '0', 'tabContent', '0', 'contentId'])
      const promotionContentType = pmSection.getIn([sectionId, 'data', 'data', 'tabs', '0', 'tabContent', '0', 'contentType'])

      return {
        promotionContentId,
        promotionContentType,
        staticText: staticText.getIn(['data', 'promotion', 'data'], Map()),
      }
    },
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setEventDefault: actions.eventTracking.setEventDefault,
        sendOptimizelyFeatureEvent: actions.optimizelyFeature.sendOptimizelyFeatureEvent,
      }
    },
  ),
)(PromotionWinback)
